import { useState } from 'preact/compat';
import useTimeout from '../../../../hooks/useTimeout';
import { Rate } from '../../../../interfaces/Rate.interface';

const AUTO_CLOSE_MODAL_DURATION = 10000;

export const useRatingModal = (onCloseCallback, onRateSuccessCallback?) => {
  const [ratedSuccess, setRatedSuccess] = useState(false);
  const [newRating, setNewRating] = useState<Rate | null>(null);
  const [setAutoCloseTimeout, clearAutoCloseTimeout] = useTimeout(() => {
    onClose();
  }, AUTO_CLOSE_MODAL_DURATION);

  function onClose() {
    onCloseCallback();
    setRatedSuccess(false);
    setNewRating(null);
    clearAutoCloseTimeout();
  }

  const onRateSuccess = (rating: Rate) => {
    onRateSuccessCallback?.(rating);
    setNewRating(rating);
    setRatedSuccess(true);
    setAutoCloseTimeout();
  };

  return {
    ratedSuccess,
    newRating,
    onRateSuccess,
    onClose,
  };
};
